/**
 * İstemci tarafı hata ve log maskeleme araçları (G41).
 * E-posta, token/sır benzeri dizgiler (≥24 karakter) ve URL sorgu parametreleri temizlenir.
 */

const EMAIL_REGEX = /[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}/g;
const TOKEN_REGEX = /\b[A-Za-z0-9_-]{24,}\b/g;
const QUERY_REGEX = /(\?|&)([^=&\s#]+)=([^&\s#]*)/gi;

/** E-posta adreslerini maskeler. */
export function maskEmail(str: string): string {
  if (!str) return "";
  return str.replace(EMAIL_REGEX, "[REDACTED_EMAIL]");
}

/** Token ve gizli anahtar benzeri dizgileri (≥24 karakter) maskeler. */
export function maskToken(str: string): string {
  if (!str) return "";
  return str.replace(TOKEN_REGEX, "[REDACTED_TOKEN]");
}

/** URL sorgu parametrelerini maskeler. */
export function maskQueryParams(str: string): string {
  if (!str) return "";
  return str.replace(QUERY_REGEX, "$1$2=[REDACTED]");
}

/** Metindeki tüm hassas alanları sırayla maskeler. */
export function maskText(str: string): string {
  if (!str) return "";
  return maskToken(maskEmail(maskQueryParams(str)));
}

/** Hata nesnesi veya yığın izini maskeler. */
export function maskError(err: unknown): { message: string; stack?: string } {
  if (err instanceof Error) {
    return {
      message: maskText(err.message),
      stack: err.stack ? maskText(err.stack) : undefined,
    };
  }
  if (typeof err === "string") {
    return {
      message: maskText(err),
    };
  }
  if (err && typeof err === "object") {
    const obj = err as { message?: unknown; stack?: unknown };
    const msg = obj.message !== undefined ? String(obj.message) : String(err);
    const stack = obj.stack !== undefined ? String(obj.stack) : undefined;
    return {
      message: maskText(msg),
      stack: stack ? maskText(stack) : undefined,
    };
  }
  return {
    message: maskText(String(err ?? "Bilinmeyen hata")),
  };
}
